import React, { useState } from "react";
import { X, Search, User } from "lucide-react";
import { ClinicAvailableSlotDto } from "@/src/web-api-client";
import { getClinicDefaultimg } from "../../../../utils/defaultImage";
import { useBackToCloseModal } from "../../../../hooks/useBackToCloseModal";

//MOBILE
interface ClinicModalProps {
  clinics: ClinicAvailableSlotDto[];
  setShowBottomSheet: (show: boolean) => void;
  showBottomSheet: boolean;
  handleClinicSelect: (clinic: ClinicAvailableSlotDto) => void;
  clinicDefaultImg: string;
}

const ClinicModal = ({
  clinics,
  setShowBottomSheet,
  showBottomSheet,
  handleClinicSelect,
  clinicDefaultImg,
}: ClinicModalProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredClinics = clinics.filter((clinic) =>
    clinic.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useBackToCloseModal(
    showBottomSheet,
    () => setShowBottomSheet(false),
    "clinic-modal"
  );

  return (
    <div>
      {/* Search and Filter */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Tìm kiếm phòng khám..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-lg w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>

      {/* clinics List */}
      <div className="overflow-y-auto max-h-[62vh]">
        <div className="p-4 space-y-4">
          {filteredClinics.map((clinic) => (
            <div
              key={clinic.clinicId}
              className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-green-300 hover:shadow-md transition-all duration-200 cursor-pointer"
              onClick={() => {
                handleClinicSelect(clinic);
              }}
            >
              <div className="flex items-start h-[100px]">
                {/* clinic Image */}
                <div className="h-full w-[100px] md:w-56 flex-shrink-0 relative overflow-hidden">
                  <img
                    src={clinic.imageUrl ?? getClinicDefaultimg()}
                    alt={clinic.name}
                    className="w-auto h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>

                {/* clinic Info */}
                <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
                  <div className="space-y-2">
                    {/* Header with name and rating */}
                    <div className="flex items-start justify-between">
                      <h3 className="text-base font-semibold text-card-foreground leading-tight line-clamp-2">
                        {clinic.name}
                      </h3>
                    </div>

                    {/* Description with 2-line truncation */}
                    <p
                      className="text-muted-foreground text-sm leading-5 h-10 overflow-hidden"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        lineHeight: "1.25rem",
                      }}
                    >
                      {clinic.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredClinics.length === 0 && (
          <div className="p-8 text-center">
            <User className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">
              Không tìm thấy phòng khám phù hợp
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClinicModal;
